import styled from "styled-components";

export const ModalHeading = styled.p`
  margin: 16px 0;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes["2xl"]};
  color: ${({ theme }) => theme.colors.black};
  line-height: 1.3;
`;
export const ModalContainer = styled.div`
  text-align: center;
`;

export const SubHeading = styled.p`
  line-height: 1.4;
  font-size: ${({ theme }) => theme.fontSizes.md};
`;
export const InfoText = styled.p``;

export const LinkText = styled.p`
  color: ${({ theme }) => theme.colors.brand["500"]};
  cursor: pointer;
`;

export const TextContainer = styled.div`
  display: flex;
  margin-top: 10px;
  flex-direction: row;
  justify-content: center;
  gap: 5px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;
